// extracted by mini-css-extract-plugin
module.exports = {"result":"FirstLast_result__5q_II","sep":"FirstLast_sep__1etxN"};